import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { take } from 'rxjs';
import { resolveBrowserLanguage } from '../core/i18n/browser-language';
import { LandingMotion } from './landing-motion';

export { resolveBrowserLanguage } from '../core/i18n/browser-language';

@Component({
  selector: 'app-landing-page',
  standalone: true,
  imports: [RouterLink, TranslocoPipe],
  templateUrl: './landing-page.html',
  host: { class: 'landing-page block min-h-full' },
})
export class LandingPage implements AfterViewInit, OnDestroy {
  private readonly element = inject(ElementRef<HTMLElement>);
  private readonly i18n = inject(TranslocoService);
  private readonly title = inject(Title);
  private motion?: LandingMotion;
  protected readonly menuOpen = signal(false);
  protected readonly scrolled = signal(false);

  constructor() {
    const language = resolveBrowserLanguage(navigator.language);
    this.i18n.setActiveLang(language);
    document.documentElement.lang = language === 'pt' ? 'pt-BR' : language;
    this.i18n.selectTranslate('landing.meta.title', {}, language).pipe(take(1)).subscribe(title => this.title.setTitle(title));
  }

  ngAfterViewInit(): void {
    this.onScroll();
    this.motion = new LandingMotion(this.element.nativeElement);
  }

  ngOnDestroy(): void {
    this.motion?.destroy();
  }

  @HostListener('window:scroll')
  protected onScroll(): void {
    this.scrolled.set(window.scrollY > 24);
  }

  @HostListener('document:keydown.escape')
  protected closeMenu(): void {
    this.menuOpen.set(false);
  }
}

